module.exports = __webpack_public_path__ + "static/024.thumb-eb200c8d5f6d9624a9037b915cffe6bb.jpg";